import React, { useState } from "react";
import StepTabs from "../../../../../Components/Stepbar/Steptabs";
import EditFAQ from "../EditSupport/EditFAQ";
import EditDoc from "./EditDocuments";
import "../ResourceStyle.css";

const EditSupportInfo = () => {
  const tabNames = ["Edit FAQs", "Edit Documents"];
  return (
    <div>
      <StepTabs size={"large "} tabNames={tabNames}>
        <EditFAQ />
        <EditDoc />
      </StepTabs>
    </div>
  );
};
export default EditSupportInfo;
